import { withStyles } from "@material-ui/core";

const getVideoAlignmentClasses= (alignment) => {
  const ALIGNMENT_CLASS_MAPPING = {
    left: '',
    right: 'alignRight',
    center: 'alignCenter'
  };
  return ALIGNMENT_CLASS_MAPPING[alignment];
};

const styles = () => ({
  videoContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    padding: '0px 16px',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  alignRight: {
    justifyContent: 'flex-end',
    alignItems: 'flex-end'
  },
  alignCenter: {
    justifyContent: 'center',
    alignItems: 'center'
  }
});
const VideoPlayer = ({ videoURL, width, height, alignment, autoPlay, classes }) => {
  const alignmentClasses = getVideoAlignmentClasses(alignment ?? 'left');
  return (
    <div className={`${classes.videoContainer} ${alignmentClasses}`}>
      <video
        src={videoURL}
        controls
        width={width ?? '768'}
        height={height ?? '432'}
        autoPlay={autoPlay ?? true}>
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default withStyles(styles)(VideoPlayer);
